var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ornament-border",style:(`--borderWidth: ${_vm.width || '80px'}; border-image-source: url(${require('@/assets/border_ornament_test9.svg')});`)})
}
var staticRenderFns = []

export { render, staticRenderFns }